/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */
import React from "react";
import { v2 } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";
const COMPONENT_NAME = "CCP/hooks/useSendEvents";
let currentAgent = null;
/**
 * This Hook will return a method for sending messages straight to the currently selected connect contact.
 *
 * The method returned will expect an object containing the following fields:
 * message: The value of the message to be sent.
 * contentType: The content type of the message.
 * @returns (Object) => void
 */
const useSendEvents = () => {
	const [sendMessage, setSendMessage] = React.useState(undefined);
	React.useEffect(() => {
		const agentSubscription = window.connect.agent((agent) => {
			currentAgent = agent;
		});

		const events = window.connect.core.getEventBus();
		const viewContactSubscription = events.subscribe(window.connect.ContactEvents.VIEW, async (event) => {
			if (currentAgent) {
				const contact = currentAgent.getContacts().find((contact) => contact.contactId === event.contactId);
				if (contact && contact.getType() !== "task") {
					const cnn = contact.getConnections().find((c) => c.getType() === window.connect.ConnectionType.AGENT);
					if (!cnn) {
						return;
					}
					try {
						const { controller } = await cnn.getMediaController();
						if (controller) {
							setSendMessage(() => (value) => controller.sendMessage(value));
						}
					} catch (_error) {
						//getMediaController throws when the media controller is no longer available IE: contact in after call work.
						return;
					}
				}
			}
		});
		return () => {
			agentSubscription.unsubscribe();
			viewContactSubscription.unsubscribe();
			currentAgent = null;
		};
	}, []);

	return (
		sendMessage ||
		(() => {
			v2.warn("Failed to send message to contact.", {
				componentName: COMPONENT_NAME,
				logCode: errorCodes.SEND_EVENTS_HOOK_WARNING,
			});
		})
	);
};
export default useSendEvents;
